export default class RoleNames {
    public static readonly User: string = 'user';
    public static readonly SysAdmin: string = 'sysadmin';
    public static readonly Analytics: string = 'analytics';
    public static readonly AssistantToolEditors: string =
        'assistant-tool-editors';
    public static readonly AssistantMCPEditors: string =
        'assistant-mcp-editors';
}
